import React, {Component} from 'react';
import {withRouteData, Link} from 'react-static';
import styled from 'styled-components';

import { isLoggedIn, logoutUser as logout } from '../utils/UserManager';

import logoSrc from '../resources/images/logo.svg';
import iconMenu from '../resources/images/icon-menu.svg';

import FlagCN from '../resources/images/languageflags/cn.png';
import FlagDE from '../resources/images/languageflags/de.png';
import FlagEN from '../resources/images/languageflags/en.png';
import FlagES from '../resources/images/languageflags/es.png';
import FlagFR from '../resources/images/languageflags/fr.png';
import FlagIT from '../resources/images/languageflags/it.png';
import FlagJP from '../resources/images/languageflags/jp.png';
import FlagKR from '../resources/images/languageflags/kr.png';
import FlagNL from '../resources/images/languageflags/nl.png';
import FlagPL from '../resources/images/languageflags/pl.png';
import FlagRU from '../resources/images/languageflags/ru.png';
import FlagPT from '../resources/images/languageflags/pt.png';

const HeaderStyle = styled.div`
	@media screen and (min-width: 64em) {
	  a {
	    font-size: 16px; } }
	
	@media screen and (max-width: 63.9375em) {
	  a {
	    font-size: 16px; } }
	
	@media screen and (max-width: 39.9375em) {
	  a {
	    font-size: 16px; } }

	padding: 20px 50px 17px;
	border-bottom: 1px solid rgba(131, 245, 248, 0.1);
	position: relative;
	z-index: 9;
	
	.button {
		margin-left: 20px;
	}
	.header-inside {
        display: none;
    }
    .header-small {
		padding-top: 9px;
	}
	
	.header-item {
		padding: 20px;
		font-weight: 500;
		display: inline-block;
		transition: color 100ms ease;
		&:hover {
			color: #83F5F8;
		}
	}
	
	.header-logo {
		display: inline-block;
		width: 91px;
		height: 37px;
		background-position-x: 50%;
        background-position-y: center;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url(${logoSrc});
		margin-right: 40px;
		vertical-align: middle;
		position: relative;
		top: -2px;
		
	}
	
	.header-toggle:not(.active) {
		max-height: 0;
		transition: max-height 200ms ease;
	}
	
	.header-toggle {
		overflow: hidden;
		max-height: 400px;
		transition: max-height 500ms ease;
		
		.header-toggleWrap {
			padding: 15px 0;
		}
		.header-item, .button {
			display: block;
			text-align: center;
			padding: 10px;
		}
		.button {
			max-width: 200px;
			margin: auto;
			margin-top: 5px;
		}
	}
	
	.dropdown {
	    position: relative;
	    display: inline-block;
        margin-right: 20px;
        
        span {
            cursor: pointer;
        }
	    
	    &-current {
	        max-height: 31px;
            padding: 0;
            cursor: pointer;
            margin-right: 10px;
	    }
	    
	    &-overlay {
		    display: none;
		    position: fixed;
		    top: 0;
		    right: 0;
		    bottom: 0;
		    left: 0;
		    z-index: 1
		}
		
		&-inner {
		    position: absolute;
		    opacity: 0;
		    visibility: hidden;
		    z-index: 12;
		    
			min-width: 100%;
			padding: 0 2px;
			background: rgba(131, 245, 248, 0.3);
			border-radius: 3px;
			transition: opacity .3s, visibility .3s;
			
			min-width: 66px;
            text-align: left;
            right: 0;
			
			img {
	            height: 31px;
				cursor: pointer;
				padding: 2px;
			}
		
			&.active {
			    opacity: 1;
			    visibility: visible
		    }
		}
	}
	
	@media screen and (max-width: 1023px) {
	    padding: 20px 20px 17px;
	    .header-logo {
	        top: 0;
	    }
	    
	    .dropdown-current {
	        max-height: 37px;
	    }
	}
`;

const BannerStyle = styled.div`
    position: relative;
    z-index: 8;
    text-align: center;
	padding: 0.3rem;
	background: rgba(224, 22, 157, 0.75);
	
	p {
	    margin: 0;
    }
    
    a {
        font-weight: bold;
    }
`;

class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			headerExpanded: false,
			languageDropdown: false
		};

		this.flags = {
			// "cn": FlagCN,
			"de": FlagDE,
			"en": FlagEN,
			"es": FlagES,
			"fr": FlagFR,
			"it": FlagIT,
			// "jp": FlagJP,
			// "kr": FlagKR,
			"nl": FlagNL,
			"pl": FlagPL,
			"ru": FlagRU,
			"pt": FlagPT
		};

		this.flagList = Object.entries(this.flags).map((value) => (
			<img src={value[1]} onClick={() => this.changeLanguage(value[0])} key={`language-flags-${value[0]}`} alt={`Change language to ${value[0]}`} />
		));

		this.changeLanguage = this.changeLanguage.bind(this);
		this.toggleHeader = this.toggleHeader.bind(this);
		this.toggleLanguageDropdown = this.toggleLanguageDropdown.bind(this);
		this.getCurrentLanguage = this.getCurrentLanguage.bind(this);
		this.getCurrentFlag = this.getCurrentFlag.bind(this);
		this.logoutUser = this.logoutUser.bind(this);
	}

	toggleHeader() {
		this.setState(prevState => ({
			headerExpanded: !prevState.headerExpanded
		}));
	}

	toggleLanguageDropdown() {
		this.setState(prevState => ({
			languageDropdown: !prevState.languageDropdown
		}));
	}

	changeLanguage(language) {
        this.props.history.push(`/${language}${this.props.match.url.replace(`/${this.getCurrentLanguage()}`, '')}`); // TODO: Make replace safer
		this.toggleLanguageDropdown();
	}

	getCurrentLanguage() {
		return this.props.language === "" ? "en" : this.props.language;
	}

	getCurrentFlag() {
		return (this.flags[this.getCurrentLanguage()] === undefined) ? this.flags.en : this.flags[this.getCurrentLanguage()];
	}

	logoutUser(event) {
		event.preventDefault();
		logout();
        this.props.history.push(`${this.props.language === "" ? "" : "/"}${this.props.language}/`);
	}

	render() {

		const currentFlaglist = this.flagList.filter((item) => item.key !== `language-flags-${this.getCurrentLanguage()}`);
		const authenticated = isLoggedIn();

		return (
			<div>
				<HeaderStyle>
					<div className="header-large show-for-large">
						<div className="row expanded collapse">
							<div className="columns medium-6">
								<Link className="header-logo" exact to={`${this.props.language === "" ? "" : "/"}${this.props.language}/`}/>
								<Link className="header-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/product`}>{ this.props.navigation.product }</Link>
								<Link className="header-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/team`}>{ this.props.navigation.team }</Link>
								<Link className="header-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/economy`}>{ this.props.navigation.economy }</Link>
								{/*<Link className="header-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/ico`}>{ this.props.navigation.ico }</Link>*/}
							</div>
							<div className="columns medium-6 medium-text-right">
								<div className="dropdown">
									<span onClick={this.toggleLanguageDropdown}>
										<img src={this.getCurrentFlag()} className="dropdown-current header-item header-outside" alt={`County flag ${this.getCurrentLanguage().toUpperCase()}`} />
										{ this.getCurrentLanguage().toUpperCase() }
									</span>
									<div className={`dropdown-inner ${this.state.languageDropdown ? 'active' : ''}`}>
										{ currentFlaglist }
									</div>
								</div>
								{/* <Link className="header-item header-outside" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/redeem-code`}>{ this.props.navigation.redeemCode }</Link> */}
								{ authenticated &&
									<span>
										<Link className="header-item header-outside" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/account`}>{ this.props.navigation.account }</Link>
										<a className="header-item header-outside" onClick={ this.logoutUser } href="javascript:">{ this.props.navigation.logout }</a>
									</span>
								}
								{ !authenticated &&
									<span>
										<Link className="header-item header-outside" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/login`}>{ this.props.navigation.login }</Link>
										{/* <a className="button header-signup header-outside" href="https://firstblockchain.fund/business-invite/an0kphtdmoyt2opxe">{ this.props.navigation.becomeBacker }</a> */}
										<Link className="button header-signup header-outside" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/signup`}>{ this.props.navigation.becomeBacker }</Link>
									</span>
								}
							</div>
						</div>
					</div>
					<div className="header-small  hide-for-large">
						<div className="row expanded collapse">
							<div className="columns small-6">
								<Link className="header-logo" exact to={`${this.props.language === "" ? "" : "/"}${this.props.language}/`}/>
							</div>
							<div className="columns small-6 text-right">
								<div className="dropdown">
									<img src={this.getCurrentFlag()} className="dropdown-current header-item header-outside" onClick={this.toggleLanguageDropdown} alt={`County flag ${this.getCurrentLanguage().toUpperCase()}`} />
									<div className={`dropdown-inner ${this.state.languageDropdown ? 'active' : ''}`}>
										{ currentFlaglist }
									</div>
								</div>
								<img className="header-menuIcon" src={iconMenu} onClick={this.toggleHeader} alt="Expand Navbar" />
							</div>
						</div>
						<div className={`header-toggle ${this.state.headerExpanded ? 'active' : ''}`}>
							<div className="header-toggleWrap">
								<Link className="header-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/product`}>{ this.props.navigation.product }</Link>
								<Link className="header-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/team`}>{ this.props.navigation.team }</Link>
								<Link className="header-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/economy`}>{ this.props.navigation.economy }</Link>
								{/*<Link className="header-item" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/ico`}>{ this.props.navigation.ico }</Link>*/}
								{ authenticated &&
									<span>
										<Link className="header-item header-outside" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/account`}>{ this.props.navigation.account }</Link>
										<a className="header-item header-outside" onClick={ this.logoutUser } href="javascript:">{ this.props.navigation.logout }</a>
									</span>
								}
								{ !authenticated &&
									<span>
										<Link className="header-item header-outside" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/login`}>{ this.props.navigation.login }</Link>
										{/* <a className="button header-signup header-outside" href="https://firstblockchain.fund/business-invite/an0kphtdmoyt2opxe">{ this.props.navigation.becomeBacker }</a> */}
										<Link className="button header-signup header-outside" to={`${this.props.language === "" ? "" : "/"}${this.props.language}/signup`}>{ this.props.navigation.becomeBacker }</Link>
									</span>
								}
							</div>
						</div>
					</div>
				</HeaderStyle>
				{/*
					<BannerStyle>
						<p>{ this.props.navigation.demoDisclaimer } { this.props.navigation.signup }</p>
					</BannerStyle>
				*/}
			</div>
		)
	}
}

export default withRouteData(Header)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Header.js